import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable} from "rxjs";
import {ClienteService} from "./cliente.service";
import {ActivatedRoute} from "@angular/router";
import {ProdutoService} from "./produto.service";

@Injectable()
export class ConstantsService{
  private moduloPedido = new BehaviorSubject<boolean>(null);
  private moduloFidelidade = new BehaviorSubject<boolean>(null);
  private moduloFiado = new BehaviorSubject<boolean>(false);
  private moduloApp = new BehaviorSubject<boolean>(false);
  private empresa = new BehaviorSubject<any>(null);
  private franquia = new BehaviorSubject<any>(null);
  private campoCpf = new BehaviorSubject<any>(null);
  private campoCnpj = new BehaviorSubject<any>(null);
  private campoDataNascimento = new BehaviorSubject<any>(null);
  private cardapioLoja = new BehaviorSubject<any>(null);
  private tagsProdutos = new BehaviorSubject<any>(null);
  diasDaSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
  moduloPedido$ = this.moduloPedido.asObservable();
  moduloFidelidade$ = this.moduloFidelidade.asObservable();
  moduloFiado$ = this.moduloFiado.asObservable();
  moduloApp$ = this.moduloApp.asObservable();
  empresa$ = this.empresa.asObservable();
  franquia$ = this.franquia.asObservable();
  tagsProdutos$ = this.tagsProdutos.asObservable();
  campoCpf$ = this.campoCpf.asObservable();
  campoCnpj$ = this.campoCnpj.asObservable();
  campoDataNascimento$ = this.campoDataNascimento.asObservable();
  produtosLoja: any = [];
  brindesDaLoja: any = [];
  tabelaDePrecosCarregada: any = null;

  cardapioLoja$: any  = this.cardapioLoja.asObservable();
  categoriasDaLoja: any = [];
  carregou  = false;
  carregandoCardapio = false;
  eventSource: any
  timerTabelaPrecos: any;
  empresaCardapio: any;
  tipoCardapioCarregado: string;
  recarregandoPorTabelaPrecos = false;
  readonly usuarioLogado: any;

  constructor(private httpClient: HttpClient,  private clienteService: ClienteService,
              private produtoService: ProdutoService,
              private activatedRoute: ActivatedRoute) {
    window.addEventListener('focus', () => this.verifiqueTabelaPrecosCarregada());
  }

  recarregueEmpresa(mesa: boolean = false) {
    let idOperador = null;

    if( !idOperador )
      idOperador = localStorage.getItem('operador');

    this.empresa.next(null);
    this.clienteService.obtenhaEmpresa(idOperador, mesa).then((dados) => {
      this.carregou = true;
      this.carregueInformacoesDeHorarioDeFuncionamento(dados.empresa);
      dados.empresa.tema = dados.empresa.tema || 'tema_padrao';
      dados.empresa.tagsProdutos = dados.tagsProdutos || [];
      this.empresa.next ( dados.empresa );
      this.moduloPedido.next( this.possuiModulo(dados.empresa, 'pedidos')  )
      this.moduloFidelidade.next( this.possuiModulo(dados.empresa, 'fidelidade')  )
      this.moduloFiado.next( this.possuiModulo(dados.empresa, 'fiado')  )
      this.moduloApp.next( this.possuiModulo(dados.empresa, 'app')  )
      this.campoCpf.next( this.obtenhaCampoExtra(dados.empresa, 'cpf'))
      this.campoCnpj.next( this.obtenhaCampoExtra(dados.empresa, 'cnpj'))
      this.campoDataNascimento.next( this.obtenhaCampoExtra(dados.empresa, 'datanascimento'))
      if(dados.empresa)
        window['tema'] = dados.empresa.tema;

    });
  }

  obtenhaCarpadioCompleto(tipo: string, empresa: any){
    if(!this.categoriasDaLoja.length)
      this.carregueCardapio(tipo, empresa);
    else {
      setTimeout(() => {
        let dados: any = { categorias: this.categoriasDaLoja}

        if(!this.carregandoCardapio){
          dados.produtos = this.produtosLoja;
          dados.brindes = this.brindesDaLoja;
          dados.tabelaDePrecosCarregada = this.tabelaDePrecosCarregada;
        }

        this.cardapioLoja.next(dados) ;
      })
    }

    return this.cardapioLoja$;
  }

  carregueCardapio(tipoCardapio: string, empresa: any){
    if(this.carregandoCardapio) return;

    this.carregandoCardapio = true;
    this.empresaCardapio = empresa;
    this.tipoCardapioCarregado = tipoCardapio;

    console.log('chamou carregue')
    const eventSourceConfig: any = {
      headers:  { 'nomeempresa':  empresa.dominio}
    };

    let url =  String(`/api/produtos/venda/${tipoCardapio}/async?`) ;

    this.eventSource = new EventSource(url, eventSourceConfig);

    this.eventSource.addEventListener('categorias', (event: any) => {
      console.log('chamou event listener categorias')
      const data = JSON.parse(event.data);
      this.categoriasDaLoja = data.categorias;
      this.cardapioLoja.next({ categorias: this.categoriasDaLoja})
    });

    this.eventSource.addEventListener('produtos', (event: any) => {
      const data = JSON.parse(event.data);
      this.produtosLoja = data.produtos;
      this.brindesDaLoja = data.brindes;
      this.atualizeTabelaDePrecosCarregada(data.tabelaDePrecosCarregada || null);
      this.cardapioLoja.next({
        produtos: this.produtosLoja,
        brindes: this.brindesDaLoja,
        tabelaDePrecosCarregada: this.tabelaDePrecosCarregada,
        recarregouPorTabela: this.recarregandoPorTabelaPrecos
      })
      this.recarregandoPorTabelaPrecos = false;
      this.carregandoCardapio = false;
      this.eventSource.close();
    });
  }

  private atualizeTabelaDePrecosCarregada(tabela: any) {
    const tabelaAnteriorId = this.tabelaDePrecosCarregada?.id;
    const tabelaAnteriorData = this.normalizeDataTabelaPrecos(this.tabelaDePrecosCarregada?.dataUltimaAtualizacao);

    this.tabelaDePrecosCarregada = tabela || null;

    if(!this.tabelaDePrecosCarregada?.id) {
      this.pareMonitoramentoTabelaPrecos();
      return;
    }

    const mudouTabela = Number(tabelaAnteriorId) !== Number(this.tabelaDePrecosCarregada.id);
    const mudouData = tabelaAnteriorData !== this.normalizeDataTabelaPrecos(this.tabelaDePrecosCarregada.dataUltimaAtualizacao);

    if(!this.timerTabelaPrecos || mudouTabela || mudouData)
      this.inicieMonitoramentoTabelaPrecos();
  }

  private inicieMonitoramentoTabelaPrecos() {
    this.pareMonitoramentoTabelaPrecos();
    this.timerTabelaPrecos = setInterval(() => this.verifiqueTabelaPrecosCarregada(), 60000);
  }

  private pareMonitoramentoTabelaPrecos() {
    if(this.timerTabelaPrecos) {
      clearInterval(this.timerTabelaPrecos);
      this.timerTabelaPrecos = null;
    }
  }

  private verifiqueTabelaPrecosCarregada() {
    if(this.carregandoCardapio || !this.tabelaDePrecosCarregada?.id || !this.empresaCardapio)
      return;

    const tabelaCarregada = this.tabelaDePrecosCarregada;
    this.produtoService.obtenhaStatusTabelaPrecosCarregada(tabelaCarregada.id, this.tipoCardapioCarregado)
      .then((status: any) => {
        if(!this.tabelaDePrecosCarregada || Number(this.tabelaDePrecosCarregada.id) !== Number(tabelaCarregada.id))
          return;

        const dataAtual = this.normalizeDataTabelaPrecos(status?.dataUltimaAtualizacao);
        const dataCarregada = this.normalizeDataTabelaPrecos(tabelaCarregada.dataUltimaAtualizacao);
        const tabelaAtualId = Number(status?.tabelaAtual?.id || 0);

        if(!status?.disponivel || dataAtual !== dataCarregada ||
          (tabelaAtualId && tabelaAtualId !== Number(tabelaCarregada.id)))
          this.recarregueCardapioPorTabela();
      })
      .catch((erro) => console.error('Erro ao verificar tabela de precos carregada', erro));
  }

  private recarregueCardapioPorTabela() {
    if(!this.empresaCardapio || !this.tipoCardapioCarregado)
      return;

    this.produtoService.removaDaCache(this.empresaCardapio, this.tipoCardapioCarregado);
    this.categoriasDaLoja = [];
    this.recarregandoPorTabelaPrecos = true;
    this.carregueCardapio(this.tipoCardapioCarregado, this.empresaCardapio);
  }

  private normalizeDataTabelaPrecos(data: any): string {
    return data ? String(data) : '';
  }

  possuiCampoExtra(empresa: any, nomeCampo){
    if(!empresa || !empresa.camposExtras) return false;

    return empresa.camposExtras.some(campoExtra =>   campoExtra.nome === nomeCampo);
  }

  obtenhaCampoExtra(empresa: any, nomeCampo){
    if(!empresa || !empresa.camposExtras) return null;

    return  empresa.camposExtras.find(campoExtra =>   campoExtra.nome === nomeCampo)
  }

  possuiModulo(empresa: any, nomeModulo: string) {
    if(!empresa || !empresa.modulos) return false;

    return empresa.modulos.some(modulo =>   modulo.nome === nomeModulo);
  }

  private carregueInformacoesDeHorarioDeFuncionamento(empresa: any) {

    //todo migrar codigo para informaçao ficar vincuulado ao serviço ou forma retirada
    //exibir somente retirada tiver habilitada
    if(empresa.estaAberta) {
      empresa.formasDeEntrega.forEach( (forma: any) => {
         if(forma.tempoMinimo && forma.tempoMaximo) {
           let unidade = forma.unidadeTempo === 'HORAS' ? 'h' : (forma.unidadeTempo === 'DIAS' ? 'dias' : 'min');
           empresa.descricaoTempoEntrega =  String(`${forma.tempoMinimo} ~ ${forma.tempoMaximo} ${unidade}`);
         }
         if(forma.tempoMinimoRetirada && forma.tempoMaximoRetirada) {
           let unidade = forma.unidadeTempo === 'HORAS' ? 'h' : (forma.unidadeTempo === 'DIAS' ? 'dias' : 'min');
           empresa.descricaoTempoRetirada = String(`${forma.tempoMinimoRetirada} ~ ${forma.tempoMaximoRetirada} ${unidade}`);
         }
      });
    }
  }
}
